import React from 'react';
import styled from 'styled-components';

export const Div = styled.div`
  height: 2px;
  border-radius: 50rem;
  background: #EDF2F7;
  margin: 0 auto;

  ${props => props.small && `
    max-width: 10rem;
    height: 4px;
  `}

  ${props => props.contain && `
    max-width: 1152px;
  `}
`;

export default props => {
  return (
    <Div {...props} />
  )
}
